import { API } from '../utils/amplifyApi';
import { UpdateStatusByCodeFormData } from '../containers/Application/Forms/UpdateApplicationStatusByCodeForm';
import { Application, CreateApplicationData, CreateInstantRentApplicationData, PartnerLead, UpdateApplicationStatusParams } from '../types/applications';
const makeInstaformRequest = async (apartmentCode: string, language: string, utfSource: string, formData: any, applicationId: string): Promise<Application> => {
    const requestsData: any = {
        name: formData.firstName + ' ' + formData.lastName,
        email: formData.email,
        phone: formData.phone,
        // eslint-disable-next-line camelcase
        utf_source: utfSource || 'unknown',
        firstName: formData.firstName,
        lastName: formData.lastName,
        apartmentCode,
        language,
        // language === 'en'
        // hasFinSSN, // TODO
        age: formData.age,
        gender: formData.gender,
        movingAbout: formData.movingAbout,
        lifeSituation: formData.lifeSituation,
        lifeSituationCustom: formData.lifeSituationCustom,
        jobSeekerNote: formData.jobSeekerNote,
        // livelihoodDescription: formData.livelihood.join(', '), // 'Työmarkkinatuen' // Підтримка ринку праці
        livelihood: formData.livelihood,
        livelihoodCustom: formData.livelihoodCustom,
        listingURL: '---',
        readyForMoveDate: formData.readyForMoveDate,
        movingWith: formData.movingWith,
        // movingWith === asGroup
        movingWithAmount: formData.movingWithAmount,
        // movingWith !== 'alone'
        // movingWithDescription, // TODO
        movingWithChildrenAmount: formData.movingWithChildrenAmount,
        depositPaymentMethod: formData.depositPaymentMethod,
        // depositPaymentMethod === 'other'
        // depositPaymentDescription, // TODO
        depositPaymentMethodCustom: formData.depositPaymentMethodCustom,
        creditStatus: formData.creditStatus,
        creditStatusNote: formData.creditStatusNote,
        // requestsData.language !== 'en' || requestsData.hasFinSSN !== 'yes'
        rentalDebts: formData.rentalDebts,
        // lifeSituation === 'other' || depositPaymentMethod === 'kelaObligation' || creditStatus === 'bad' || (language === 'en' && hasFinSSN === 'no')
        guarantorPossible: formData.guarantorPossible,
        // wroteNotes === 'yesy'
        notes: formData.notes,
        spouseLifeSituation: formData.spouseLifeSituation,
        spouseLifeSituationCustom: formData.spouseLifeSituationCustom,
        spouseJobSeekerNote: formData.spouseJobSeekerNote,
        spouseLivelihood: formData.spouseLivelihood,
        spouseLivelihoodCustom: formData.spouseLivelihoodCustom,
        spouseCreditStatus: formData.spouseCreditStatus,
        spouseCreditStatusNote: formData.spouseCreditStatusNote,
        spouseGuarantorPossible: formData.spouseGuarantorPossible,
        // Leea has no tenant radar consent checkbox
        contactInformationConsent: false,
        profilePicture: formData.profilePicture,
        cognitoSub: formData.cognitoSub
    };
    if (typeof formData.pets !== 'undefined' && formData.pets !== null) {
        requestsData.pets =
            formData.pets === 'none' ? 'no' : 'yes';
        if (formData.pets !== 'none') {
            requestsData.petType =
                formData.pets === 'myAnswer'
                    ? formData.petsCustom
                    : formData.pets;
        }
    }
    // if (requestsData.language === 'en' && requestsData.hasFinSSN === 'yes') {
    //   requestsData.language === 'fi'
    // }
    /*
    {
      - objectId: Joi.number(),
      + listingURL: Joi.string(),
      ? address: Joi.string(),
      + name: Joi.string().required(),
      + email: Joi.string().required(),
      + phone: Joi.string().required(),
      + language: Joi.string(),
      + lifeSituation: Joi.string(),
      + livelihoodDescription: Joi.string(),
      + movingWith: Joi.string(),
      + movingWithAmount: Joi.string(),
      -- movingWithDescription: Joi.string(),
      + pets: Joi.string(),
      + petType: Joi.string(),
      + readyForMoveDate: Joi.any(),
      + depositPaymentMethod: Joi.string(),
      + depositPaymentDescription: Joi.string(),
      + creditStatus: Joi.string(),
      - collateralDescription: Joi.string(),
      + notes: Joi.string(),
      + status: Joi.string().required()
    }
      */
    let postUrl = '/applications/form';
    if (applicationId) {
        postUrl = `/applications/update/${applicationId}`;
    }
    const application: Application = await API.post('applications', postUrl, {
        body: requestsData
    });
    return application;
};
//=============================== INSTANT RENT =============================//
const startInstantRent = async (payload: CreateInstantRentApplicationData) => {
    const application: Application = await API.post('applications', '/applications/instant-rent/start', {
        body: payload
    });
    return application;
};
const updateInstantRent = async (payload: any) => {
    const application: Application = await API.post('applications', '/applications/instant-rent/update', {
        body: payload
    });
    return application;
};
const initiatePayment = async (payload: any) => {
    const application: Application = await API.post('applications', '/applications/instant-rent/initiatePayment', {
        body: payload
    });
    return application;
};
const instantGeneratePDF = async (authInfo: any) => {
    const authResponse = await API.get('applications', `/applications/${authInfo.applicationCode}?generatePdf=true`, {});
    return authResponse;
};
const getApplicationByCode = async (code: string) => {
    const application: Application = await API.get('applications', `/applications/${code}`, {});
    return application;
};
const getApplication = async (apartmentId: string, applicationId: string) => {
    const application: Application = await API.get('applications', `/apartments/${apartmentId}/applications/${applicationId}`, {});
    return application;
};
const getApplications = async () => {
    const response = await API.get('applications', `/applications`, {});
    const compressedData = response.body;
    const binaryData = Uint8Array.from(atob(compressedData), (c) => c.charCodeAt(0));
    const ds = new DecompressionStream('gzip');
    const writer = ds.writable.getWriter();
    writer.write(binaryData);
    writer.close();
    const decompressedStream = ds.readable;
    const decompressedResponse = new Response(decompressedStream);
    const decompressedText = await decompressedResponse.text();
    return JSON.parse(decompressedText);
};
const getMyApplications = async () => {
    const applications: Application[] = await API.get('applications', '/applications/my', {});
    return applications;
};
const getMyProfile = async () => {
    return API.get('applications', '/profile/my', {});
};
const getTenantProfileContact = async (slug: string): Promise<{ email: string }> => {
    return API.get('applications', `/profiles/${slug}/contact`, {});
};
const updateMyProfile = async (data: Record<string, any>) => {
    return API.put('applications', '/profile/my', { body: data });
};
const linkMyApplication = async (applicationCode: string, apartmentId: string, applicationId: string) => {
    return API.post('applications', '/applications/my/link', { body: { applicationCode, apartmentId, applicationId } });
};
const getApartmentApplications = async (apartmentId: string) => {
    const apartmentApplicationsList: Application[] = await API.get('applications', `/apartments/${apartmentId}/applications`, {});
    return apartmentApplicationsList;
};
const updateApplicationPhoneShown = async (apartmentId: string, applicationId: string): Promise<Application> => {
    const application: Application = await API.put('applications', `/apartments/${apartmentId}/applications/${applicationId}/phoneShown`, {});
    return application;
};
const updateApplicationStatus = async (apartmentId: string, applicationId: string, status: UpdateApplicationStatusParams) => {
    const application: Application = await API.put('applications', `/apartments/${apartmentId}/applications/${applicationId}/status`, {
        body: status
    });
    return application;
};
const acceptApplication = async (apartmentId: string, applicationId: string, confirmImmediately?: boolean) => {
    const acceptedApplication: Application = await API.put('applications', `/apartments/${apartmentId}/applications/${applicationId}/accept`, { body: { confirmImmediately } });
    return acceptedApplication;
};
const rejectApplication = async (apartmentId: string, applicationId: string) => {
    const rejectedApplication: Application = await API.put('applications', `/apartments/${apartmentId}/applications/${applicationId}/reject`, {});
    return rejectedApplication;
};
const editApplication = async (apartmentId: string, applicationId: string, editedApplicationData: CreateApplicationData) => {
    const updatedApplication: Application = await API.post('applications', `/apartments/${apartmentId}/applications/${applicationId}/edit`, {
        body: editedApplicationData
    });
    return updatedApplication;
};
const updateApplicationAdminNotes = async (apartmentId: string, applicationId: string, adminNotes: any) => {
    const application: Application = await API.post('applications', `/apartments/${apartmentId}/applications/${applicationId}/adminNotes`, {
        body: adminNotes
    });
    return application;
};
/** only allows to update to status notInterested and noAvailableTimes */
const updateApplicationStatusByCode = async (code: string, data: UpdateStatusByCodeFormData) => {
    const application: Application = await API.post('applications', `/applications/${code}/status`, {
        body: data
    });
    return application;
};
const getLeadData = async (leadId: string) => {
    const partnerLead: PartnerLead = await API.get('applications', `/applications/imported/${leadId}`, {});
    return partnerLead;
};
const getConversationData = async (applicationid: string) => {
    const conversationData: PartnerLead = await API.get('applications', `/conversation/talk/${applicationid}`, {});
    return conversationData;
};
const initiatePaymentForPublish = async (payload: any) => {
    //console.log("initiatePaymentForPublish")
    const response = await API.post('applications', '/payforpublish/initiatePayment', {
        body: payload
    });
    return response;
};
const handlePaymentCoupon = async (couponCode: string, userId: string, useCase: string) => {
    const response = await API.post('applications', '/payforpublish/handlePaymentCoupon', {
        body: {
            couponCode: couponCode,
            userId: userId,
            useCase: useCase
        }
    });
    return response;
};
const initiateAuthorizationForCreditScore = async (payload: any) => {
    const response = await API.post('applications', '/payforpublish/creditScoreAuthInit', {
        body: payload
    });
    return response;
};
const generateContractPDF = async (contract: any) => {
    const response = await API.post('applications', `/payforpublish/generateContractPDF`, {
        body: {
            contract: contract
        }
    });
    return response;
};
const saveContractDraft = async (contract: any) => {
    const response = await API.post('applications', `/payforpublish/saveContractDraft`, {
        body: {
            contract: contract
        }
    });
    return response;
};
const sendContractForSigning = async (contract: any) => {
    const response = await API.post('applications', `/payforpublish/sendContractForSigning`, {
        body: {
            contract: contract
        }
    });
    return response;
};
const downloadContract = async (apartmentId: string, applicationId: string, isLandlord = false) => {
    const response = await API.get('applications', `/contracts/${apartmentId}/${applicationId}/download${isLandlord ? '?landlord=true' : ''}`, {});
    return response;
};
const cancelDocument = async (identifiers: any, documentId?: string) => {
    const body: any = {
        identifiers: identifiers,
        platform: 'leea'
    };
    if (documentId) {
        body.documentId = documentId;
    }
    const response = await API.post('applications', `/payforpublish/cancelDocument`, { body });
    return response;
};
const updateAfterShowingApplication = async (payload: any) => {
    const application: Application = await API.post('applications', '/payforpublish/update', {
        body: payload
    });
    return application;
};
const contactApplicant = async (applicationId: string, apartmentId: string, landlordUserId: string) => {
    const body = {
        applicationId,
        apartmentId,
        landlordUserId
    };
    const response = await API.post('applications', '/contactapplicant', {
        body: body
    });
    return response;
};
// const deleteApplicationByCode = async (code: string) => {
//   const body = {
//     code
//   }
//   const response = await API.post(
//     'applications',
//     '/deletebycode',
//     {
//       body: body
//     }
//   )
//   return response
// }
const checkIfLandlordUsedChat = async (apartmentId: string, applicationId: string, apartmentUserId: string) => {
    const response = await API.get('applications', `/apartments/${apartmentId}/applications/${applicationId}/checkIfChatUsed/${apartmentUserId}`, {});
    //console.log(response)
    return response;
};
const addContractInformation = async (apartmentId: string, applicationId: string, payload: any) => {
    try {
        const response = await API.post('applications', `/apartments/${apartmentId}/applications/${applicationId}/addcontractinformation`, {
            body: payload
        });
        //console.log(response)
        return response;
    }
    catch (error) {
        console.error('An error occurred while adding contract information', error);
        throw error;
    }
};
const sendAfterShowingMail = async (email: string, code: string, phone?: string) => {
    try {
        const body = {
            email,
            code,
            ...(phone ? { phone } : {})
        };
        const response = await API.post('applications', '/sendaftershowingmail', {
            body: body
        });
        //console.log(response)
        return response;
    }
    catch (error) {
        console.error('An error when sending aftershowing mail', error);
        throw error;
    }
};
const addFinancialInfo = async (applicationCode: string, applicantCode?: string) => {
    try {
        const response = await API.post('applications', '/addfinancialinfo', {
            body: { applicationCode, ...(applicantCode ? { applicantCode } : {}) }
        });
        return response;
    } catch (error) {
        console.error('An error using addfinancialinfo function', error);
        throw error;
    }
};
const addRights = async (application: string, products: Array<string>) => {
    try {
        const response = await API.post('applications', '/addrights', {
            body: {
                application,
                products
            }
        });
        return response;
    }
    catch (error) {
        console.error('Error adding products:', error);
    }
};
const getFinancialInfo = async (applicationCode: string) => {
    try {
        const response = await API.get('applications', `/getfinancialinfo/${applicationCode}`, {});
        //console.log(response)
        return response;
    }
    catch (error) {
        console.error('An error using addfinancialinfo function', error);
        throw error;
    }
};
const getBudgetReportPdf = async (applicationCode: string, applicantCode?: string) => {
    try {
        const query = applicantCode ? `?applicantCode=${encodeURIComponent(applicantCode)}` : '';
        const response = await API.get('applications', `/budgetreportpdf/${applicationCode}${query}`, {});
        return response;
    }
    catch (error) {
        console.error('Error fetching budget report PDF:', error);
        throw error;
    }
};
const getCreditInfo = async (applicationId: string, apartmentId: string) => {
    try {
        const response = await API.post('applications', '/applications/getcreditinfo', {
            body: {
                applicationId,
                apartmentId
            }
        });
        return response;
    }
    catch (error) {
        console.error('Error fetching credit info', error);
        throw error;
    }
};
const createTenantForDigivakuus = async (payload: {
    applicationCode: string;
    applicantCode: string;
    bank: string;
    acceptedDepositService: boolean;
}) => {
    try {
        const response = await API.post('applications', '/securitydeposit/tenant', {
            body: payload
        });
        return response;
    }
    catch (error) {
        console.error('Error creating tenant for Digivakuus', error);
        throw error;
    }
};
const checkDigivakuusEligibility = async (payload: {
    applicationCode: string;
    applicantCode: string;
}) => {
    try {
        const response = await API.post('applications', '/securitydeposit/eligibility', {
            body: payload
        });
        return response;
    }
    catch (error) {
        console.error('Error checking Digivakuus eligibility', error);
        throw error;
    }
};
const requestAuth = async (applicationCode: string) => {
    return API.post('applications', `/applications/${applicationCode}/requestAuth`, {
        body: {}
    });
};
const deleteTalkConversation = async (conversationId: string) => {
    return API.post('applications', '/talkjs/deleteconversation', {
        body: { conversationId }
    });
};
export default {
    createApplication: makeInstaformRequest,
    acceptApplication,
    getApplication,
    getApplicationByCode,
    getApplications,
    getMyApplications,
    getApartmentApplications,
    updateApplicationPhoneShown,
    updateApplicationStatus,
    rejectApplication,
    updateApplicationAdminNotes,
    editApplication,
    updateApplicationStatusByCode,
    startInstantRent,
    initiatePayment,
    instantGeneratePDF,
    updateInstantRent,
    getLeadData,
    getConversationData,
    initiatePaymentForPublish,
    handlePaymentCoupon,
    initiateAuthorizationForCreditScore,
    generateContractPDF,
    updateAfterShowingApplication,
    sendContractForSigning,
    saveContractDraft,
    downloadContract,
    cancelDocument,
    contactApplicant,
    checkIfLandlordUsedChat,
    addContractInformation,
    sendAfterShowingMail,
    addFinancialInfo,
    addRights,
    getFinancialInfo,
    getBudgetReportPdf,
    getCreditInfo,
    createTenantForDigivakuus,
    checkDigivakuusEligibility,
    deleteTalkConversation,
    requestAuth,
    getMyProfile,
    updateMyProfile,
    linkMyApplication,
    getTenantProfileContact
};
